/**
 * Created by Victor Rojo on 14/10/19.
 */
import { Component, ViewChild, ElementRef }     from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

import {PetrolStatisticsService} from "./PetrolStatistics.service";
import {BsDatepickerViewMode} from "ngx-bootstrap/datepicker/models/index";

import * as jsPDF from 'jspdf';

@Component({
  templateUrl: './PetrolStatistics.component.html',
  styleUrls: ['./PetrolStatistics.component.css']
})
export class PetrolStatisticsComponent {

  statistics: any[];
  isLoading = true;
  month: Date;
  maxDate = new Date();
  bsConfig: Partial<BsDatepickerConfig>;
  @ViewChild('content', { static: true }) content: ElementRef;

  constructor(private petrolStatisticsService: PetrolStatisticsService) {

    let startDate = new Date();
    let endDate = new Date();
    startDate.setMonth(startDate.getMonth() -1, 1);
    startDate.setHours(0,0,0,0);
    endDate.setDate(1);
    endDate.setHours(0,0,0,0);

    this.month = startDate;

    this.reloadStattistics(startDate.getTime(), endDate.getTime());

    let minMode: BsDatepickerViewMode = 'month';

    this.bsConfig = Object.assign({}, {
      containerClass: "theme-custom left-align",
      showWeekNumbers: false,
      minMode: minMode
    });
  }

  reloadStattistics(startMillis, endMillis){
    this.isLoading = true;
    this.petrolStatisticsService.get(startMillis, endMillis)
      .then(data => {
        this.statistics = data;
        this.isLoading = false;
      });
  }

  onDateChange(value){
    if ( !this.isLoading ) {
      value.setDate(1);
      value.setHours(0,0,0,0);
      let startDate = value;
      let endDate = new Date(value.getTime());
      endDate.setMonth(startDate.getMonth() +1, 1);
      this.reloadStattistics(startDate.getTime(), endDate.getTime());
    }
  }

  downloadReport(){
    if ( !this.isLoading ) {

      let doc = new jsPDF('p', 'mm', 'a4');
      doc.fromHTML(this.content.nativeElement, 15, 15, {
        'width': 600,
      });
      doc.save('statistics.pdf');

    }
  }

}
